// Module
var code = `<form-section form-title="\$ctrl.incomeFormTitle">
  <form-section-field field-title="'Income source'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'source')">
    <select type="text"
            ng-model="\$ctrl.sourceOfIncome.type"
            ng-disabled="true"
            ng-options="entry.code as entry.description for entry in \$ctrl.types">
      <option></option>
    </select>
  </form-section-field>
  <form-section-field field-title="'Primary'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'primary')">
    <select ng-model="\$ctrl.sourceOfIncome.primary"
            ng-class="{'non-valid-primary-income-source': !\$ctrl.hasOnePrimaryIncomeSource()}"
            ng-disabled="!\$ctrl.editMode"
            ng-change="\$ctrl.primaryIncomeSourceChanged(\$ctrl.sourceOfIncome, \$index)"
            boolean-options>
    </select>
  </form-section-field>
  <form-section-field field-title="'Other existing bank accounts'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'other_existing_bank_accounts')">
    <select
      ng-model="\$ctrl.sourceOfIncome.otherExistingBankAccounts"
      ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'other_existing_bank_accounts')"
      ng-change="\$ctrl.updateBankId()"
      ng-disabled="!\$ctrl.editMode"
      boolean-options>
    </select>
  </form-section-field>
  <form-section-field field-title="'Other existing bank accounts Bank'"
                      ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'income', 'other_existing_bank_accounts_bank_id')
                              && \$ctrl.sourceOfIncome.otherExistingBankAccounts">
    <selectize options="\$ctrl.banks"
               config="\$ctrl.bankSelectConfig"
               ng-model="\$ctrl.sourceOfIncome.otherExistingBankAccountsBankId"
               ng-required="\$ctrl.cfg.required(\$ctrl.module, 'income', 'other_existing_bank_accounts_bank_id')
                    || \$ctrl.sourceOfIncome.otherExistingBankAccounts"
               ng-disabled="!\$ctrl.editMode">
    </selectize>
  </form-section-field>
</form-section>

<div ng-show="\$ctrl.editMode" ng-if="\$ctrl.module !== 'agent' || !\$ctrl.sourceOfIncome.id">
  <button ng-click="\$ctrl.removeIncomeSource(\$ctrl.sourceOfIncome)"
          class="btn btn-danger btn--align-with-form-field" type="button">
    Remove source of income
  </button>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/income-source/other-bank-accounts-income-source.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;